<div class="dialog-header" cdkDrag 
cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle >
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-icon>drag_indicator</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="form" class="dialog-content">
    <!-- Principal Department -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Department</mat-label>
      <input matInput [value]="deptName" placeholder="Select a department" readonly />
      <button 
        class="margin-xs-right"
        mat-button 
        matSuffix
        (click)="openDeptSelectDialog()">
        Select
      </button>
    </mat-form-field>

    <!-- Effort Name -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Effort Title</mat-label>
      <input matInput formControlName="title" #titleInput />
    </mat-form-field>

    <!-- Effort Key -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Effort Key</mat-label>
      <input matInput formControlName="key" appSlugInput [sourceInput]="titleInput" required />
      <mat-error *ngIf="form.get('key')?.hasError('required')">Effort key is required</mat-error>
    </mat-form-field>

    <mat-checkbox formControlName="isDeleted">Is Archived</mat-checkbox>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="save()" [disabled]="form.invalid || !form.get('principalGroupId')?.value">Save</button>
  <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
